import enLocale from './en'
export default {
  ...enLocale,
  
  // Top level translations
  language: '언어',
  confirm: '확인',
  status: '상태',
  balance: '잔액',
  cash: '현금',
  createNew: '새로 만들기',
  home: '홈',
  market: '마켓',
  markets: '마켓',
  portfolio: '포트폴리오',
  license: '라이선스',
  withdraw: '출금',
  auditChecking: '심사 진행중',
  insufficientFunds: '잔액 부족',
  buy: '구매',
  history: '히스토리',
  seeMore: '더 보기',
  theme: '테마',
  network: '네트워크',
  walletBalance: '지갑 잔액',
  collect: '수집',
  approve: '승인',
  ticket: '라이선스',
  category: '카테고리',
  sortBy: '정렬',
  issue: '발행',
  detail: '상세',
  stakingType: '담보',
  stakingTypeInfo: '발행자의 악의적인 결과 확인을 방지하기 위해 토큰이나 현재 NFT를 스테이킹해주세요.',
  subscriptionAmount: '구독 금액',
  subscription: '구독',
  subscribe: '구매',
  max: '최대',
  marketClosed: '시장 종료',
  add: '추가',
  deposit: '입금',
  verifiedNFT: '확인된 라이선스 확인',
  select: '선택',
  selected: '선택됨',
  moreNFT: '라이선스 더 받기',
  forecastEvent: '이벤트',
  subscribeEndDate: '최종 거래 시간',
  specifyLastTradingDate: '최종 거래 시간 지정',
  specifyExpiryDate: '만료 시간 지정',
  endDate: '종료 시간',
  validityPeriod: '만료 시간',
  marketEndDate: '만료 시간',
  liquidityMin: '최소 유동성',
  premiumMin: '최소 프리미엄',
  paymentCurrency: '결제 통화',
  defaultOdds: '기본 레버리지',
  setDefaultOdds: '레버리지 설정',
  minInvestAmout: '최소 투자 금액 설정',
  depositMargin: '유동성 추가',
  totalPayment: '총 결제액',
  rewards: '보상',
  rewardRate: '보상율',
  release: '해제',
  fee: '수수료',
  marginFeeRate: '수수료율',
  cdsInfoOne: '예측 상품을 발행할 때 마진을 스테이킹하고 기본 레버리지와 최소 투자 금액을 설정해야 합니다.',
  cdsInfoTwo: '미참여 마진은 언제든지 인출할 수 있습니다.',
  cdsInfoThree: '사용자의 1명 이상이 판정 결과에 이의를 제기하면 커뮤니티 거버넌스 메커니즘이 시작되어 예측 이벤트가 발생했는지 결정됩니다.',
  deposited: '투자됨',
  issued: '발행됨',
  deposit: '입금',
  depositedCDS: '투자 상품',
  totalProfit: '총 수익',
  allOrDeposited: '전체/투자',
  rewardsOrProfit: '보상/수익',
  estimatedInvested: '예상/투자',
  profit: '수익',
  yesterdayProfit: '어제 수익',
  eventConfirming: '이벤트 확인 중',
  appeal: '이의 제기',
  appealing: '이의 제기 중',
  appealFailed: '이의 제기 실패',
  occured: '발생',
  notOccured: '미발생',
  governanceMechanism: '이의 제기 수가 1명을 초과할 때 거버넌스 메커니즘을 시작합니다.',
  appealLimit: '이의 제기 수가 1명을 넘지 않습니다.',
  waitResult: '이의 제기 결과 대기',
  frozenMargin: '동결 마진',
  marginBalance: '마진 잔액',
  cancel: '취소',
  defaultAhead: '조기 발생',
  occur: '발생',
  notOccur: '미발생',
  stakingToChallenge: '챌린지를 위한 스테이킹',
  challenged: '챌린지됨',
  checking: '확인 중',
  fail: '실패',
  appealInfoOne: '현재 예측 이벤트의 판정이 사실과 다르다고 생각하면 "챌린지"를 하고 거버넌스 메커니즘을 시작하여 현재 예측 결과를 최종적으로 결정할 수 있습니다.',
  check: '확인',
  contentIllegal: '예측 이벤트에 부적절한 내용이 포함되어 있습니다. 다시 편집하여 발행하세요.',
  subscribed: '투자 상품',
  receivingCompensation: '보류 중',
  received: '총 지급',
  receive: '수신',
  compensationAmount: '발생 보상 금액',
  liquidity: '유동성',
  injectLiquidity: '유동성 주입',
  uRLContent: 'URL/내용',
  resolutionSource: '판정 소스',
  textareaInfo: '이 이벤트를 간단히 설명하세요.',
  empowering: '선견지명을 가진 사람들이 미래를 예측하도록 힘을 주다',
  createYourOwnMarket: '자신만의 마켓 만들기',
  buyTicket: '티켓 구매',
  amount: '수량',
  
  licenses: '라이선스',
  prediLicense: 'Predi 라이선스',
  issuableQuantity: '발행 가능 수량',
  disabled: '비활성화됨',
  battleImage: '배틀 이미지',
  upload: '업로드',
  showSample: '샘플 보기',
  battleInformation: '배틀 정보',
  baseToken: '기초 토큰',
  collateral: '담보',
  currentLicense: '현재 라이선스',
  predictionProject: '예측 프로젝트:',
  issueExpireIntro: '만료 시간에 올바른 옵션을 선택한 사람들이 참여 지분에 따라 상품 풀의 토큰을 공유합니다.',
  issueParticipateUntil: '사용자는 다음까지 이 상품에 참여할 수 있습니다',
  issueConfirmAdvance: '만료 시간 전에 이벤트가 발생하면 발행자가 결과를 사전에 확인할 수 있습니다.',
  issueChallengeWithin7Days: '참가자가 발행자가 확인한 이벤트 결과에 동의하지 않으면 확인 후 7일 이내에 "챌린지"할 수 있습니다.',
  issueAttention: '주의: Predi는 엔터테인먼트와 사회적 경험을 촉진하는 데 전념합니다. 모든 형태의 도박 관련 활동은 이 플랫폼에서 엄격히 금지됩니다.',
  eventSampleTitle: '이벤트',
  issueSampleCrypto: '[암호화폐] 2025년 말 비트코인의 가격 범위는?',
  issueSampleFinance: '[금융] 2025년 3분기 미국 연준의 금리 결정은?',
  issueSampleTechnology: '[기술] 어떤 회사가 최초의 완전 자율 AI 로봇 어시스턴트를 출시할까요?',
  issueSampleSports: '[스포츠] 어떤 팀이 2026년 FIFA 월드컵을 우승할까요?',
  issueSampleSociety: '[사회] 2025년 월간 활성 사용자가 가장 많은 소셜 미디어 플랫폼은?',
  issueSampleOthers: '[기타] 러시아-우크라이나 전쟁은 언제 끝날까요?',
  issuerResult: '발행자 결과',
  daoResult: 'DAO 결과',
  predictionToken: '예측 토큰',
  issuer: '발행자',
  issuerProfit: '발행자 수익',
  
  donations: '기부',
  
  // Issue.vue notifications (top-level)
  issueMsgPleaseSelectLicense: '라이선스를 선택하세요',
  issueMsgLicenseCannotBeStaked: '라이선스를 스테이킹할 수 없습니다',
  issueMsgNetworkNotConnected: '네트워크가 연결되지 않음',
  issueMsgEventEmpty: '이벤트가 비어있습니다',
  issueMsgSelectLicense: '라이선스 선택',
  issueMsgLastTradingDateEmpty: '최종 거래 시간이 비어있습니다',
  issueMsgExpirationDateEmpty: '만료 시간이 비어있습니다',
  issueMsgOptionsEmpty: '옵션을 비워둘 수 없습니다',
  issueMsgOptionsLessThanTwo: '옵션이 두 개 미만일 수 없습니다',
  issueMsgOptionEmpty: '옵션 내용을 비워둘 수 없습니다',
  issueMsgOptionRepeated: '옵션 내용을 반복할 수 없습니다',
  issueMsgLastTradingDateGreaterThanToday: '최종 거래 시간은 오늘보다 커야 합니다',
  issueMsgLastTradingDateGreaterThanExpirationDate: '최종 거래 시간이 만료 시간보다 큽니다',
  issueMsgEventEndDateGreaterThanRentalEndDate: '이벤트 종료 시간 {eventEndDate}은(는) 대여 종료 시간 {rentalEndDate}보다 큽니다',
  issueMsgInsufficientBalance: '잔액 부족',
  issueMsgTransactionFailed: '트랜잭션 실패',
  issueMsgIssueSuccess: '발행 성공',
  issueMsgTransactionCancelled: '트랜잭션이 취소되었습니다',
  
  short: {
    confirmsEventAdvance: '조기 발생',
    waitConfirmation: '확인 대기 중',
    defaultChallenging: '발생-챌린지 중',
    notDefaultChallenging: '미발생-챌린지 중',
    defaultChallengeFailed: '발생-챌린지 실패',
    notDefaultChallengeFailed: '미발생-챌린지 실패',
    defaultWaitingResult: '발생-거버넌스 중',
    notDefaultWaitingResult: '미발생-거버넌스 중',
    defaultGovernanceMechanism: '발생-거버넌스 확인됨',
    notDefaultGovernanceMechanism: '미발생-거버넌스 확인됨'
  },
  
  wallet: {
    openWallet: '지갑 열기',
    connectWallet: '지갑 연결',
    connectingWallet: '지갑 연결 중',
    connectYourWallet: '지갑 연결',
    disconnect: '연결 해제',
    wrongNetwork: '잘못된 네트워크'
  },
  
  NFT: {
    getPrediLicense: 'Predi 라이선스 받기',
    referralRewards: '추천 보상',
    mintYourLicence: '라이선스 민팅',
    usageRights: '사용 권한',
    issuePredictionProducts: '예측 상품 발행',
    governance: '거버넌스',
    properties: '속성',
    tradable: '거래 가능',
    rentable: '임대 가능',
    usable: '사용 가능',
    marketsToIssue: '발행할 마켓',
    times: '회',
    availableTimes: '가능 횟수',
    ticketId: '티켓 ID',
    cancelRentHint: '이 라이선스는 임대 중입니다. 판매하려면 먼저 취소하세요.',
    seeMore: '더 보기',
    sell: '판매',
    rent: '임대',
    share: '공유',
    USDT: 'USDT',
    common: '일반',
    scarcity: '희소성',
    attributive: '속성',
    numbers: '발행 수',
    issueTip: '라이선스당 10개의 예측 마켓 발행',
    price: '가격',
    success: '성공',
    getNFT: '라이선스 획득 성공',
    issueCDS: 'Predi 마켓 발행',
    buyNow: '지금 구매',
    mintNow: '지금 민팅',
    rule: '규칙',
    comingSoon: '곧 출시!',
    type: '유형',
    from: '발신',
    to: '수신',
    me: '나',
    rented: '임대됨',
    sold: '판매됨',
    tabGetLicense: '라이선스 받기',
    tabMyLicense: '내 라이선스',
    bought: '구매됨',
    boughtProducts: '구매한 상품',
    investedProducts: '투자한 상품',
    issuedProducts: '발행한 상품',
    positions: '포지션',
    options: '옵션',
    all: '전체',
    volume: '거래량',
    newest: '최신',
    price: '가격',
    pending: '대기 중',
    audit: '심사',
    loading: '로딩 중',
    home: '홈',
    market: '마켓',
    markets: '마켓',
    portfolio: '포트폴리오',
    license: '라이선스',
    myPositions: '내 포지션',
    challengeCredit: '챌린지 크레딧',
    challengeStatus: '챌린지 상태',
    succeed: '성공',
    wait: '대기',
    return: '반환',
    waitChallenge: '이벤트가 챌린지를 기다리고 있습니다.',
    waitingGovernanceResult: '이벤트가 거버넌스 메커니즘 결과를 기다리고 있습니다.',
    eventFinished: '이벤트가 종료되었습니다.',
    cancelled: '취소됨',
    predictionProduct: '예측 상품',
    complaintCountdown: '이의 제기 카운트다운',
    setResult: '결과 설정',
    challenge: '챌린지',
    recycleTicket: '티켓 회수',
    eventCancelled: '이벤트가 취소되었습니다.',
    auditChecking: '심사 진행중',
    insufficientFunds: '잔액 부족',
    buyTicket: '티켓 구매',
    buy: '구매',
    listYourToken: '토큰 나열',
    setResultModalTitle: '결과 설정:',
    cancelModalTitle: '취소',
    cancelIrreversible: '취소는 되돌릴 수 없습니다.',
    challengeModalTitle: '챌린지',
    challengeStakeIntro: '사실이 다르면 반환됩니다.',
    challengeStakeButton: '챌린지를 위한 PRDS',
    history: '히스토리',
    seeMore: '더 보기'
  },
  
  claim: {
    title: 'PRDs 무료로 받기',
    subtitle: '원클릭으로 PRDs 토큰 받기',
    walletAddress: '지갑 주소',
    status: '상태',
    connectWalletFirst: '먼저 지갑을 연결하세요',
    eligibility: {
      claimed: '이미 받으셨습니다',
      eligible: '받을 자격이 있습니다',
      error: '자격 확인 오류'
    },
    button: {
      claim: '받기',
      alreadyClaimed: '이미 받음',
      connect: '연결'
    },
    footerNotice: '각 지갑은 한 번만 받을 수 있습니다. 올바른 네트워크에 연결되어 있는지 확인하세요.',
    messages: {
      connectFirst: '먼저 지갑을 연결하세요',
      claimSuccess: '받기 성공!',
      claimFailed: '받기 실패, 나중에 다시 시도하세요',
      txCancelled: '트랜잭션이 취소되었습니다',
      onlyOnce: '각 사용자는 한 번만 받을 수 있습니다',
      insufficientBalance: '계약 잔액이 부족합니다. 나중에 다시 시도하세요'
    }
  },
  
  // Additional top level keys
  inputSearchText: '검색 내용을 입력하세요',
  predictionProduct: '예측 상품',
  listYourToken: '토큰 나열',
  description: '설명',
  setResultModalTitle: '결과 설정:',
  cancelModalTitle: '취소',
  cancelIrreversible: '취소는 되돌릴 수 없습니다.',
  challengeModalTitle: '챌린지',
  challengeStakeIntro: '사실이 다르면 반환됩니다.',
  challengeStakeButton: '챌린지를 위한 PRDS',
  
  issuerResult: '발행자 결과',
  daoResult: 'DAO 결과',
  waitingGovernanceResult: '이벤트가 거버넌스 메커니즘 결과를 기다리고 있습니다.',
  eventFinished: '이벤트가 종료되었습니다.',
  recycleTicket: '티켓 회수',
  eventCancelled: '이벤트가 취소되었습니다.',
  challenge: '챌린지',
  share: '공유',
  USDT: 'USDT'
}